// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface Arrange1To9IconSignature {
  Element: SVGSVGElement;
}

export const Arrange1To9Icon: TOC<Arrange1To9IconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 11H18V4H16V2H19C19.552 2 20 2.448 20 3V11ZM9 3V17.586L11.293 15.293L12.707 16.707L8 21.414L3.293 16.707L4.707 15.293L7 17.586V3H9ZM20 13H16C15.448 13 15 13.448 15 14V18C15 18.552 15.448 19 16 19H19V20H15V22H20C20.552 22 21 21.552 21 21V14C21 13.448 20.552 13 20 13ZM17 15V17H19V15H17Z"/>
</svg>
</template>;